import { Props } from "@greeter/matter";
import { classNames } from "@greeter/util";
import css from "./AlertDescription.module.scss";

export function AlertDescription({className, ...props}: Props) {
  return <p {...classNames(className, css.AlertDescription)} {...props} />
}

